import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { colors, colorConstants, borderRadiusSizes, marginSizes } from 'theme/default'
import { setAlpha } from 'tools/style'
import Div from 'components/Div'
import Flex from 'components/Flex'
import { MobileHidden } from 'components/Responsive'
import IconArrow from 'components/Icons/IconArrow'

const ButtonContainer = styled(Flex).attrs(() => ({
  role: 'button',
  justifyContent: 'center',
  alignItems: 'center',
  height: 50,
  width: 50,
  borderRadius: borderRadiusSizes.small
}))`
  position: absolute;
  top: 50%;
  ${props => props.left ? 'left: 0;' : 'right: 0;'}
  transform: translateX(${props => props.left ? '10px' : '-10px'}) translateY(-50%);
  background-color: ${setAlpha(colorConstants.black)};
  cursor: pointer;
  z-index: 1;
`

export const PrevButton = ({ onClick }) => (
  <MobileHidden>
    <ButtonContainer onClick={onClick} left>
      <IconArrow.Left iconSize='large' fill={colorConstants.white} />
    </ButtonContainer>
  </MobileHidden>
)
PrevButton.propTypes = {
  onClick: PropTypes.func.isRequired // injected by slick
}

export const NextButton = ({ onClick }) => (
  <MobileHidden>
    <ButtonContainer onClick={onClick}>
      <IconArrow.Right iconSize='large' fill={colorConstants.white} />
    </ButtonContainer>
  </MobileHidden>
)
NextButton.propTypes = {
  onClick: PropTypes.func.isRequired // injected by slick
}

export const DotButton = styled(Div).attrs(() => ({
  margin: marginSizes.small,
  width: 12,
  height: 12,
  role: 'button'
}))`
  background-color: ${props => props.theme.buttonColor};
  border-radius: 100%;
  border: none;
  opacity: ${props => props.active ? 1 : 0.5};
  cursor: pointer;
`
DotButton.propTypes = {
  active: PropTypes.bool
}
DotButton.defaultProps = {
  theme: {
    buttonColor: colors.brandPrimary
  }
}

export const DotButtonContainer = styled(Flex)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
`
